import React, { useEffect, useMemo, useState } from "react";
import useReactRouter from "use-react-router";
import { Breadcrumb, Form } from "react-bootstrap";
import { useLazyQuery, useMutation } from "@apollo/client";
import "./styleSetting.css";
import { numberFormat } from "../../helpers";
import { UPDATE_EXCHANGERATE } from "../../graphql/exchangeRate/Mutation";
import { successUpdateSwal } from "../../helpers/sweetalert";
import ExRateList from "./ExRateList";
import { GET_EXCHANGRATE } from "../../graphql/exchangeRate/Query";

export default function ExchangeRate() {
  const { history } = useReactRouter();
  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
  const [bahtRate, setBahtRate] = useState();
  const [usdRate, setUsdRate] = useState();

  const [getExchangeRate, { data: loadExchangeRate }] = useLazyQuery(
    GET_EXCHANGRATE,
    { fetchPolicy: "cache-and-network" }
  );
  const [updateExchangerate, { loadingUpdate }] =
    useMutation(UPDATE_EXCHANGERATE);

  //   fetch exchange ret
  useEffect(() => {
    getExchangeRate({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  }, [shopId]);

  const isExChangeRate = useMemo(() => {
    return loadExchangeRate?.exchangeRate;
  }, [loadExchangeRate?.exchangeRate]);


  // update exchange rate
  const handleUpdateExchangeRate = async (e) => {
    e.preventDefault();
    const rateId = isExChangeRate?.id;

    try {
      await updateExchangerate({
        variables: {
          where: {
            id: rateId,
          },
          data: {
            baht: bahtRate,
            usd: usdRate,
          },
        },
      });

      successUpdateSwal("update exchage successfully...");
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <div style={{padding:'0 .5em'}}>
      <Breadcrumb className="header-Breadcrumb">
        <Breadcrumb.Item onClick={() => history.replace("/settings")}>
          ຕັ້ງຄ່າ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ການຕັ້ງຄ່າອັດຕາເລກປ່ຽນ</Breadcrumb.Item>
      </Breadcrumb>

      <div className="containerExchangeRate">
        <div className="card-show-rate">
          <div className="card-rete-name">
            <div className="card-baht">
              <h3>ເລດບາດ</h3>
              <h3>{numberFormat(isExChangeRate?.baht ?? 0)}</h3>
            </div>
            <div className="card-usd">
              <h3>ເລດໂດລາ</h3>
              <h3>{numberFormat(isExChangeRate?.usd ?? 0)}</h3>
            </div>
          </div>

          <div className="card-exchange-detail">
            <ExRateList />
          </div>
        </div>
        <div className="card-form-rate">
          <div
            style={{
              width: "100%",
              padding: " 1.35em",
              height: "auto",
              border: "1px solid #ddd",
              borderRadius: ".5em",
            }}>
            <h4>ອັດຕາການເລກປ່ຽນ</h4>
            <h5># ເງິນບາດ</h5>
            <div className="rate-calculator">
              <strong>100,000</strong>
              <strong>=</strong>
              <strong>
                {numberFormat(isExChangeRate?.baht * 100000 ?? 0)} ກີບ
              </strong>
            </div>
            <div className="rate-calculator">
              <strong>1,000</strong>
              <strong>=</strong>
              <strong>
                {numberFormat(isExChangeRate?.baht * 1000 ?? 0)} ກີບ
              </strong>
            </div>
            <div className="rate-calculator">
              <strong>100</strong>
              <strong>=</strong>
              <strong>
                {numberFormat(isExChangeRate?.baht * 100 ?? 0)} ກີບ
              </strong>
            </div>
            <div className="rate-calculator">
              <strong>50</strong>
              <strong>=</strong>
              <strong>
                {numberFormat(isExChangeRate?.baht * 50 ?? 0)} ກີບ
              </strong>
            </div>
            <div className="rate-calculator">
              <strong>10</strong>
              <strong>=</strong>
              <strong>
                {numberFormat(isExChangeRate?.baht * 10 ?? 0)} ກີບ
              </strong>
            </div>
            <hr />
            <h5># ເງິນໂດລາ</h5>
            <div className="rate-calculator">
              <strong>100,000</strong>
              <strong>=</strong>
              <strong>
                {numberFormat(isExChangeRate?.usd * 100000 ?? 0)} ກີບ
              </strong>
            </div>
            <div className="rate-calculator">
              <strong>1,000</strong>
              <strong>=</strong>
              <strong>
                {numberFormat(isExChangeRate?.usd * 1000 ?? 0)} ກີບ
              </strong>
            </div>
            <div className="rate-calculator">
              <strong>100</strong>
              <strong>=</strong>
              <strong>
                {numberFormat(isExChangeRate?.usd * 100 ?? 0)} ກີບ
              </strong>
            </div>
            <div className="rate-calculator">
              <strong>50</strong>
              <strong>=</strong>
              <strong>{numberFormat(isExChangeRate?.usd * 50 ?? 0)} ກີບ</strong>
            </div>
            <div className="rate-calculator">
              <strong>10</strong>
              <strong>=</strong>
              <strong>{numberFormat(isExChangeRate?.usd * 10 ?? 0)} ກີບ</strong>
            </div>
          </div>
        </div>
      </div>

      {/* 

  {loading ? (
          <div
            style={{
              display: "flex",
              height: "20vh",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <Spinner />
          </div>
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>ລຳດັບ</th>
                <th>ເລດເງິນ</th>
                <th>ສະກຸນເງິນ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{isExChangeRate?.id + 1}</td>
                <td>{isExChangeRate?.baht}</td>
                <td>{isExChangeRate?.usd}</td>
              </tr>
            </tbody>
          </Table>
        )}

*/}
    </div>
  );
}
